module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Carrot-25676461d951e79458ec91b03db3203a.svg";